export const MOBILE_FAB_BUTTON_TOKENS = {
  colorScheme: {
    light: {
      root: {
        primary: {
          background: '#09DE74',
          hoverBackground: '#07C965',
          activeBackground: '#05A653',
          borderColor: '#09DE74',
          hoverBorderColor: '#07C965',
          activeBorderColor: '#05A653',
          color: '#024653',
          hoverColor: '#024653',
          activeColor: '#024653',
        },
      },
    },
  },
  root: {
    roundedBorderRadius: '999px',
    gap: '12px',
    paddingX: '24px',
    paddingY: '16px',
    label: {
      fontWeight: '600',
    },
  },
};
